import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/styles';
import { withSnackbar } from 'notistack';
import { Redirect } from 'react-router-dom';
import PushPropertyButtons from './PushPropertyButtons';
import Notes from 'components/explore/prospector/addProperty/Notes';
import EditIcon from '@material-ui/icons/Edit';
import DomainIcon from '@material-ui/icons/Domain';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import { pushProspect } from 'api/prospector/prospects';
import { withDialog } from 'components/explore/prospector/Dialog';
import { compose } from 'recompose';
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Constants } from 'utilities/constants';
import {
    ClickAwayListener,
    FormControlLabel,
    Switch,
    FormControl,
    InputLabel,
    FormHelperText,
    Select,
    MenuItem,
    TextField,
    Button
} from '@material-ui/core';
import NumberFormatCustom from 'components/explore/prospector/addProperty/NumberFormatCustom';
import UserLocationButton from "components/explore/prospector/search/UserLocationButton";
import classNames from 'classnames';
import { toCurrency } from 'utilities/format';

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: 8,
        padding: '2px 4px',
        width: '100%',
        maxWidth: 800,
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        height: '100%',
        justifyContent: 'space-between'
    },
    selectContainer: {
        display: 'flex',
        flexWrap: 'wrap'
    },
    form: {
        width: '90%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    bullet: {
        display: 'inline-block',
        margin: '0 2px',
        transform: 'scale(0.8)'
    },
    icon: {
        marginRight: 4
    },
    small: {
        fontSize: '.6rem !important'
    },
    refContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    requiredForm: {
        width: '90%'
    },
    inputFields: {
        display: 'flex',
        flexFlow: 'column nowrap',
        alignItems: 'center',
        width: '100%'
    },
    browserLocationSection: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        marginBottom: '1rem',
        alignItems: 'center'
    },
    backButton: {
        height: '36px'
    },
    missingLocationText: {
        display: 'flex',
        alignItems: 'center'
    },
    missingLocationAsterisk: {
        color: 'red',
        marginBottom: '5px',
        marginLeft: '3px'
    },
    emptyDiv: {
        width: 60
    },
    iconButton: {
        padding: 10,
    },
    error: {
        color: theme.palette.red.main
    }
}));

const states = [
    'AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA',
    'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD',
    'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 
    'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC',
    'SD', 'TN', 'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY'
];

function PropertyDetails({ details, history, enqueueSnackbar, showDialog, user, isManuallyAdded, refreshProspectsGrid,
    setRefreshProspectsGrid, handleUserLocationButtonClick, locationStatus }) {
    const classes = useStyles();
    const [pushing, setPushing] = useState(false);
    const [notes, setNotes] = useState(null);
    const [strategy, setStrategy] = useState(null);
    const [opportunitySource, setOpportunitySource] = useState(null);
    const [price, setPrice] = useState(null);
    const [beds, setBeds] = useState(null);
    const [baths, setBaths] = useState(null);
    const [yearBuilt, setYearBuilt] = useState(null);
    const [sqft, setSqft] = useState(null);
    const [inspectionPeriod, setInspectionPeriod] = useState(true);
    const [priceErrorText, setPriceErrorText] = useState('');
    const [sqftErrorText, setSqftErrorText] = useState('');
    const [yearBuiltErrorText, setYearBuiltErrorText] = useState('');
    const [bedsErrorText, setBedsErrorText] = useState('');
    const [bathsErrorText, setBathsErrorText] = useState('');
    const [zipCodeErrorText, setZipCodeErrorText] = useState('');
    const [notesErrorText, setNotesErrorText] = useState('');
    const [prospectType, setProspectType] = useState(0);
    const [createdBy, setCreatedBy] = useState(user.id);
    const [streetAddress, setStreetAddress] = useState(details.address.streetAddress);
    const [city, setCity] = useState(details.address.city);
    const [state, setState] = useState(details.address.state);
    const [zipCode, setZipCode] = useState(details.address.zipCode);
    // const { streetAddress, city, state, zipCode } = details.address;
    const showNotes = notes !== null;
    const showStrategy = strategy !== null;
    const showOpportunitySource = opportunitySource !== null;
    const showPrice = price !== null;
    const showBeds = beds !== null;
    const showBaths = baths !== null;
    const showYearBuilt = yearBuilt !== null;
    const showSqft = sqft !== null;
    const ref = React.createRef();
    //const showDialog = useDialog();
    const pushButtonDisabled = (!streetAddress || !city || !state || !zipCode ||
        priceErrorText !== '' ||
        sqftErrorText !== '' ||
        yearBuiltErrorText !== '' ||
        bedsErrorText !== '' ||
        bathsErrorText !== '' ||
        zipCodeErrorText !== '' ||
        notesErrorText !== '' ||
        !details.location ||
        !opportunitySource);
    const flagProspect = (
        beds == null || 
        beds === '' ||
        baths == null || 
        baths === '' ||
        price == null || 
        price === '' ||
        yearBuilt == null || 
        yearBuilt === '' ||
        sqft == null || 
        sqft === '');
    function handlePushPropertyClick() {
        localStorage.removeItem('recentSuggestion');
        const prospectDetails = {
            ...details,
            address: {
                ...details.address,
                streetAddress: streetAddress,
                city: city,
                state: state,
                zipCode: zipCode
            }
        }
        const dialogText = `${flagProspect ?
            'You are about to submit a prospect with one or more indicative values missing. Please confirm. The prospect will be submitted immediately.' :
            'Please confirm. The prospect will be submitted immediately.'}`;
        showDialog({
            title: 'Submit Prospect?',
            text: dialogText,
            cancelText: 'Cancel',
            okText: 'Submit'
        })
            .then(x => {
                if (x) {
                    setPushing(true);
                    return pushProspect(
                        prospectDetails,
                        notes,
                        price,
                        inspectionPeriod,
                        strategy,
                        beds,
                        baths,
                        yearBuilt,
                        sqft,
                        prospectType,
                        createdBy,
                        opportunitySource
                    );
                }
            })
            .then(res => {
                setPushing(false);
                if (res) {
                    enqueueSnackbar(res.message, {
                        variant: res.success,
                        autoHideDuration: 2000
                    });
                    if (res.success === 'success') {
                        setRefreshProspectsGrid(refreshProspectsGrid + 1);
                        showDialog({
                            title: 'Prospect Submitted Successfully',
                            text: 'What would you like to do next?',
                            cancelText: 'Add More',
                            okText: 'Go to Prospects'
                        })
                        .then(resolve => {
                            if (resolve) {
                                console.log('Redirect to conductor ', refreshProspectsGrid);
                                history.push(Constants.Routes.EXPLORE_CONDUCTOR);
                            } else {
                                console.log('Stay on prospector');
                                history.push(Constants.Routes.EXPLORE_PROSPECTOR);
                            }
                        })
                    }
                }
            });
    }

    if (pushing === 'done') {
        return <Redirect to="/explore/prospector" />;
    }

    const renderNotes = () => {
        return showNotes ? (
            <Notes
              text={notes}
              onTextChanged={value => {
                setNotes(value);
                if (value.length > 8000) {
                  setNotesErrorText('Length of notes cannot exceed 8,000 characters.');
                } else {
                  setNotesErrorText('');
                }
              }}
              error={notesErrorText !== ''}
              helperText={notesErrorText}
            />
        ) : (
                <Button
                    className={classes.small}
                    color="primary"
                    onClick={() => setNotes('')}
                >
                    <EditIcon />
                Add Notes
                </Button>
            );
    };
    const renderBeds = () => {
        return showBeds ? (
            <FormControl fullWidth>
                <TextField
                    autoFocus
                    label="Beds"
                    placeholder="Enter number of beds"
                    value={beds}
                    error={bedsErrorText !== ''}
                    helperText={bedsErrorText}
                    onChange={e => {
                        setBeds(e.target.value)
                        if (e.target.value === '') {
                            setBedsErrorText('');
                        } else if (e.target.value < 0 || e.target.value > 99) {
                            setBedsErrorText('Number of beds must be between 0 - 99')
                        } else {
                            setBedsErrorText('');
                        }
                    }}
                    InputProps={{
                        inputComponent: NumberFormatCustom
                    }}
                    inputProps={{
                        thousandSeparator: false,
                        decimalScale: 0,
                        allowNegative: false
                    }}
                />
            </FormControl>
        ) : (
                <Button
                    className={classes.small}
                    color="primary"
                    onClick={() => setBeds('')}
                >
                    Add Beds
                </Button>
            );
    };
    const renderBaths = () => {
        return showBaths ? (
            <FormControl fullWidth>
                <TextField
                    autoFocus
                    label="Baths"
                    placeholder="Enter number of baths"
                    value={baths}
                    error={bathsErrorText !== ''}
                    helperText={bathsErrorText}
                    onChange={e => {
                        setBaths(e.target.value)
                        if (e.target.value === '') {
                            setBathsErrorText('');
                        } else if (e.target.value < 0 || e.target.value > 99) {
                            setBathsErrorText('Number of baths must be between 0 - 99')
                        } else {
                            setBathsErrorText('');
                        }
                    }}
                    InputProps={{
                        inputComponent: NumberFormatCustom
                    }}
                    inputProps={{
                        thousandSeparator: false,
                        allowNegative: false
                    }}
                />
            </FormControl>
        ) : (
                <Button
                    className={classes.small}
                    color="primary"
                    onClick={() => setBaths('')}
                >
                    Add Baths
                </Button>
            );
    };
    const renderYearBuilt = () => {
        return showYearBuilt ? (
            <FormControl fullWidth>
                <TextField
                    autoFocus
                    label="Year Built"
                    placeholder="Enter the year built"
                    error={yearBuiltErrorText !== ''}
                    helperText={yearBuiltErrorText}
                    value={yearBuilt}
                    onChange={e => {
                        const tempDate = new Date();
                        setYearBuilt(e.target.value);
                        if (e.target.value === '') {
                            setYearBuiltErrorText('');
                        } else if (e.target.value < 1890) {
                            setYearBuiltErrorText('Year Built must be greater than 1890');
                        } else if (e.target.value > tempDate.getFullYear()) {
                            setYearBuiltErrorText('Year Built cannot exceed the current year')
                        } else {
                            setYearBuiltErrorText('');
                        }
                    }
                    }
                    InputProps={{
                        inputComponent: NumberFormatCustom
                    }}
                    inputProps={{
                        thousandSeparator: false,
                        decimalScale: 0,
                        allowNegative: false
                    }}
                />
            </FormControl>
        ) : (
                <Button
                    className={classes.small}
                    color="primary"
                    onClick={() => setYearBuilt('')}
                >
                    Add Year Built
                </Button>
            );
    };
    const renderSqft = () => {
        return showSqft ? (
            <FormControl fullWidth>
                <TextField
                    autoFocus
                    label="Sq ft"
                    error={sqftErrorText !== ''}
                    helperText={sqftErrorText}
                    placeholder="Enter number of Sq ft"
                    value={sqft}
                    onChange={e => {
                        setSqft(e.target.value);
                        if (e.target.value.length > 8) {
                          setSqftErrorText('Sq ft must be less than 100,000,000');
                        } else if (e.target.value === '' || e.target.value > 0) {
                            setSqftErrorText('');
                        } else {
                            setSqftErrorText('Sq ft must be greater than 0');
                        }
                    }
                    }
                    InputProps={{
                        inputComponent: NumberFormatCustom
                    }}
                    inputProps={{
                        thousandSeparator: true,
                        decimalScale: 0,
                        allowNegative: false
                    }}
                />
            </FormControl>
        ) : (
                <Button
                    className={classes.small}
                    color="primary"
                    onClick={() => setSqft('')}
                >
                    Add Sq ft
                </Button>
            );
    };
    const renderPrice = () => {
        return showPrice ? (
            <FormControl fullWidth>
                <TextField
                    fullWidth
                    error={priceErrorText !== ''}
                    helperText={priceErrorText}
                    label="Asking Price"
                    value={price}
                    autoFocus
                    onChange={newPrice => {
                        let value = newPrice.target.value;
                        setPrice(value);
                        if (value === '') {
                            setPriceErrorText('');
                        } else if (value < Constants.UnderwriteMinAskingPrice) {
                            setPriceErrorText(`Asking Price must be at least ${toCurrency(Constants.UnderwriteMinAskingPrice, 0)}`);
                        } else if (value.length < 10) {
                            setPriceErrorText('');
                        } else {
                            setPriceErrorText('Asking Price must be less than $999,999,999');
                        }
                    }}
                    id="price-input"
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                    inputProps={{
                        prefix: '$',
                        thousandSeparator: true,
                        allowNegative: false
                    }}
                />
            </FormControl>
        ) : (
                <Button
                    className={classes.small}
                    color="primary"
                    onClick={() => setPrice('')}
                >
                    <AttachMoneyIcon />
                Add Asking Price
                </Button>
            );
    };

    const renderStrategy = () => {
        return showStrategy ? (
            <FormControl fullWidth>
                <InputLabel htmlFor="strategy">Strategy</InputLabel>
                <Select
                    value={strategy}
                    onChange={e => setStrategy(e.target.value)}
                    inputProps={{
                        name: 'strategy',
                        id: 'strategy'
                    }}
                    autoFocus
                >
                    <MenuItem value="SFR">SFR</MenuItem>
                    <MenuItem value="Bungalo">Bungalo</MenuItem>
                </Select>
            </FormControl>
        ) : (
                <Button
                    className={classes.small}
                    color="primary"
                    onClick={() => setStrategy('SFR')}
                >
                    <DomainIcon />
                Select Strategy (Default: SFR)
                </Button>
            );
    };
    const renderOpportunitySource = () => {
        return showOpportunitySource ? (
            <FormControl fullWidth error={!opportunitySource}>
                <InputLabel htmlFor="opportunitySource">Opportunity Source</InputLabel>
                <Select
                    value={opportunitySource}
                    onChange={e => setOpportunitySource(e.target.value)}
                    inputProps={{
                        name: 'opportunitySource',
                        id: 'opportunitySource'
                    }}
                    autoFocus
                >
                    <MenuItem value="Aggregator">Aggregator</MenuItem>
                    <MenuItem value="iBuyer">iBuyer</MenuItem>
                    <MenuItem value="Auction">Auction</MenuItem>
                    <MenuItem value="Broker">Broker</MenuItem>
                    <MenuItem value="Homebuilder">Homebuilder</MenuItem>
                    <MenuItem value="Operator">Operator</MenuItem>
                    <MenuItem value="Seller Direct">Seller Direct</MenuItem>
                    <MenuItem value="Wholesaler">Wholesaler</MenuItem>
                </Select>
                {!opportunitySource &&
                    <FormHelperText>Opportunity Source is required</FormHelperText>
                }
            </FormControl>
        ) : (
                <Button
                    className={classNames(classes.small, !opportunitySource && classes.error)}
                    color='primary'
                    onClick={() => setOpportunitySource('')}
                >
                Select Opportunity Source
                </Button>
            );
    };
    const href = `${Constants.Routes.EXPLORE_PROSPECTOR}`;
    return (
        <div className={classes.root}>
            <div className={classes.inputFields}>
                <div className={classes.browserLocationSection}>
                    <Button className={classes.backButton} component={Link} variant="outlined" color="primary" to={href} startIcon={<ChevronLeftIcon />}>Back</Button>
                    {(details && details.location) ? 
                        <div></div> : 
                        <div className={classes.missingLocationText}>
                            Click on the map and place a marker at the prospect location
                            <span className={classes.missingLocationAsterisk}>
                                *
                            </span>
                        </div>
                    }
                    {isManuallyAdded ?
                        <UserLocationButton className={classes.iconButton} onClick={handleUserLocationButtonClick} status={locationStatus} />
                        :
                        <div className={classes.emptyDiv}></div>
                    }
                </div>
                {isManuallyAdded ?
                    <FormControl className={classes.requiredForm}>
                        <TextField
                            label="Street"
                            placeholder="Street"
                            value={streetAddress}
                            onChange={e => setStreetAddress(e.target.value)}
                            required
                        />
                        <TextField
                            label="City"
                            placeholder="City"
                            value={city}
                            onChange={e => setCity(e.target.value)}
                            required
                        />
                        <FormControl required>
                            <InputLabel id="state">State</InputLabel>
                            <Select
                                value={state || ""}
                                onChange={e => setState(e.target.value)}
                                inputProps={{
                                    name: "state",
                                    id: "state"
                                }}
                                required
                                placeholder="State"
                            >
                                {states.map(i => {
                                    return (
                                        <MenuItem value={i} key={i}>{i}</MenuItem>
                                    )
                                })}
                            </Select>
                        </FormControl>
                        <TextField
                            label="Zip Code"
                            placeholder="Zip Code"
                            value={zipCode}
                            onChange={e => {
                                let value = e.target.value;
                                setZipCode(value);
                                if (value === '') {
                                    setZipCodeErrorText('');
                                } else if (value.length === 5) {
                                    setZipCodeErrorText('');
                                } else {
                                    setZipCodeErrorText('Zip Code must be 5 digits');
                                }
                            }}
                            required
                            error={zipCodeErrorText !== ''}
                            helperText={zipCodeErrorText}
                            id="zipCode-input"
                            InputProps={{
                                inputComponent: NumberFormatCustom,
                            }}
                            inputProps={{
                                thousandSeparator: false,
                                allowNegative: false,
                                allowLeadingZeros: true
                            }}
                        />
                    </FormControl>
                    :
                    <>
                        <Typography variant="h6">{streetAddress}</Typography>
                        <Typography variant="subtitle2">
                            {city}, {state} {zipCode}
                        </Typography>
                    </>
                }
                <div className={classes.form}>
                    <ClickAwayListener
                        onClickAway={() =>
                            (!beds || beds.length <= 0) && setBeds(null)
                        }
                    >
                        <div ref={ref} className={classes.refContainer}>{renderBeds()}</div>
                    </ClickAwayListener>
                    <ClickAwayListener
                        onClickAway={() =>
                            (!baths || baths.length <= 0) && setBaths(null)
                        }
                    >
                        <div ref={ref} className={classes.refContainer}>{renderBaths()}</div>
                    </ClickAwayListener>
                    <ClickAwayListener
                        onClickAway={() =>
                            (!yearBuilt || yearBuilt.length <= 0) && setYearBuilt(null)
                        }
                    >
                        <div ref={ref} className={classes.refContainer}>{renderYearBuilt()}</div>
                    </ClickAwayListener>
                    <ClickAwayListener
                        onClickAway={() =>
                            (!sqft || sqft.length <= 0) && setSqft(null)
                        }
                    >
                        <div ref={ref} className={classes.refContainer}>{renderSqft()}</div>
                    </ClickAwayListener>
                    <FormControlLabel
                        control={
                            <Switch
                                color="primary"
                                checked={inspectionPeriod}
                                onChange={() =>
                                    setInspectionPeriod(!inspectionPeriod)
                                }
                            />
                        }
                        label={
                            <Typography variant="body2">
                                Inspection Period?{' '}
                                <strong>{inspectionPeriod ? 'Yes' : 'No'}</strong>
                            </Typography>
                        }
                    />

                    {renderStrategy()}
                    {renderOpportunitySource()}
                    <ClickAwayListener
                        onClickAway={() =>
                            (!price || price.length <= 0) && setPrice(null)
                        }
                    >
                        <div ref={ref} className={classes.refContainer}>{renderPrice()}</div>
                    </ClickAwayListener>
                    <ClickAwayListener
                        onClickAway={() => {
                            return (!notes || notes.length <= 0) && setNotes(null)
                        }
                        }
                    >
                        <div ref={ref} className={classes.refContainer}>{renderNotes()}</div>
                    </ClickAwayListener>
                </div>
            </div>
            <PushPropertyButtons
                loading={pushing}
                onPushPropertyClicked={handlePushPropertyClick}
                disabled={pushButtonDisabled}
            />
        </div>
    );
}

function mapState(state) {
    return {
        user: state.appState.user
    };
}

const mapDispatch = null;

export default compose(
    connect(mapState, mapDispatch),
    withSnackbar,
    withDialog
)(PropertyDetails);